import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';
import { MobilityProductType } from '@telialt/models/src/EshopModel';

import { ESimNoticeContainer, ESimNoticeContent } from './ESimNotice.styles';

type Props = {
    brand: string;
    productType: MobilityProductType;
};

export const ESimNotice: FC<Props> = ({ productType, brand }) => {
    const { t, hasMessage } = useTranslations();
    const isShown = productType === MobilityProductType.EsimWatch;

    if (!isShown || !brand) {
        return null;
    }

    const messageKey = `eshop.product_esim_notice.${brand.toLowerCase()}`;

    if (!hasMessage(messageKey)) {
        return null;
    }

    const message = t[messageKey];

    return (
        <ESimNoticeContainer>
            <ESimNoticeContent dataTest={ESHOP_TEST_ID.ESIM_NOTICE} content={message} />
        </ESimNoticeContainer>
    );
};
